import { ref } from 'vue'
import { postFlyToPoint, PostFlyToPointBody, deleteFlyToPoint, postTakeoffToPoint, PostTakeoffToPointBody } from '@/api/drone-control/drone'

export function useDroneControl () {
  const droneControlPanelVisible = ref(false)

  function setDroneControlPanelVisible (visible: boolean) {
    droneControlPanelVisible.value = visible
  }

  async function flyToPoint (sn: string, body: PostFlyToPointBody) {
    const result = await postFlyToPoint(sn, body)
    ElMessage.success('飞往目标点')
  }

  async function stopFlyToPoint (sn: string) {
    const result = await deleteFlyToPoint(sn)
    ElMessage.success('急停成功')
  }

  async function takeoffToPoint (sn: string, body: PostTakeoffToPointBody) {
    const result = await postTakeoffToPoint(sn, body)
    ElMessage.success('起飞成功！')
  }

  return {
    droneControlPanelVisible,
    setDroneControlPanelVisible,
    flyToPoint,
    stopFlyToPoint,
    takeoffToPoint
  }
}
